<template>
  <ODialog ref="dialog" :maxWidth="700">
    <v-card>
      <div v-if="state == 1">
        <ODialogBar title="Selecione de onde copiar valores" @close="dismiss" />
        <v-card-text class="pa-6">
          <v-text-field
            placeholder="Filtrar..."
            v-model="keywords"
            single-line
            hide-details
            class="pt-0"
            autofocus
          />
        </v-card-text>
        <div class="maxh-4">
          <OSelectList
            :rows="filteredTechs"
            labelProp="name"
            @rowClicked="goto2"
          />
        </div>
      </div>
      <div v-if="state == 2">
        <ODialogBar title="Selecione os valores a copiar" @close="dismiss" />
        <v-simple-table>
          <thead>
            <tr>
              <td>
                <v-checkbox
                  hide-details
                  class="shrink mt-0 pt-0"
                  :input-value="allSelected"
                  @click.native.stop="selectAll()"
                />
              </td>
              <td>Item</td>
              <td class="text-right">Valor</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="r in rows" :key="r.name">
              <td style="width: 48px">
                <v-checkbox
                  hide-details
                  class="shrink mt-0 pt-0"
                  v-model="selectedNames"
                  :value="r.name"
                />
              </td>
              <td>{{ r.name }}</td>
              <td class="text-right">{{ r.value | brMoney }}</td>
              <td>
                <span v-if="r.currentValue != null">
                  Já existe com valor {{ r.currentValue | brMoney }}
                </span>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <ODialogButtons class="pa-6" @cancel="dismiss" @apply="apply" />
      </div>
    </v-card>
  </ODialog>
</template>

<script>
import { Technician } from '@/models'
import { matchAnyLike } from 'oderon-commons/src/utils'
import OSelectList from 'oderon-vue/cpts/OSelectList.vue'

export default {
  components: { OSelectList },
  data() {
    return {
      row: null,
      keywords: null,
      allTechs: [],
      selectedSource: null,
      selectedNames: [],
      state: 1
    }
  },
  computed: {
    filteredTechs() {
      return this.allTechs.filter(x => {
        return matchAnyLike(this.keywords, x.name)
      })
    },

    allSelected() {
      if (this.selectedSource == null) return false
      if (this.selectedNames.length == this.selectedSource.values.length)
        return true
      return false
    },

    rows() {
      if (this.selectedSource == null) return []

      let findCurrent = name => {
        let v = this.row.values && this.row.values.find(x => x.name == name)
        return v ? v.value : null
      }

      return this.selectedSource.values.map(x => {
        return {
          name: x.name,
          value: x.value,
          currentValue: findCurrent(x.name)
        }
      })
    }
  },
  methods: {
    open(row) {
      this.row = row
      this.state = 1
      this.selectedNames = []
      this.$refs.dialog.$loading(async () => {
        this.allTechs = await Technician.findAll()
      })
      return this.$refs.dialog.$open()
    },
    goto2(selectedSource) {
      this.selectedSource = selectedSource
      this.state = 2
    },
    selectAll() {
      if (this.allSelected) this.selectedNames = []
      else this.selectedNames = this.selectedSource.values.map(x => x.name)
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      let result = this.selectedNames.map(name => {
        let value = this.rows.find(x => x.name == name).value
        return { name, value }
      })

      this.$refs.dialog.$apply(result)
    }
  }
}
</script>

<style></style>
